import React from 'react';
import { Link } from 'react-router-dom';
import logocontablog from './assets/logo.png';
import './Blog.css';

const HeaderBlog = () => {
  return (
    <header className='blog-topbar-main-blog'>
      <div className='blog-brand'>
        <img src={logocontablog} alt='ContaLearn logo' className='blog-brand-logo' />
        
      </div>

      <nav className='blog-nav'>
        <Link to='/home' className='blog-nav-link'>Articole</Link>
        <Link to='/cursuri-prezentare' className='blog-nav-link'>Cursuri</Link>
        <a href='#posts' className='blog-nav-link'> Despre</a>
        <Link to='/functionalpagelogin' className='blog-nav-cta'>
          Incepe gratuit
        </Link>
      </nav>
    </header>
  );
};

export default HeaderBlog;
